import HomeIcon from '@mui/icons-material/Home';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GroupIcon from '@mui/icons-material/Group';
import EventNoteIcon from '@mui/icons-material/EventNote';
import type { ReactNode } from 'react';
import { ROLE } from '../brand';

export interface NavItem {
  label: string;
  path: string;
  icon: ReactNode;
  /** Roles de administración de empresa (además de SuperAdmin). Vacío en ítems solo de cobro. */
  roles?: string[];
  /** Si es true, solo SuperAdmin lo ve. */
  superOnly?: boolean;
  /** Visible para usuarios sin menú admin (solo cobro), p. ej. Operador. */
  payNav?: boolean;
}

export const ALL_ROLES = ['SuperAdmin', 'TenantAdmin', 'Operator'] as const;

export const NAV_ITEMS: NavItem[] = [
  { label: 'Inicio', path: '/home', icon: <HomeIcon />, payNav: true },
  { label: 'CAMARAS', path: '/admin/camaras', icon: <AccountTreeIcon />, roles: ['TenantAdmin'] },
  { label: 'Tarifas',        path: '/admin/fees',      icon: <PriceChangeIcon />, roles: ['TenantAdmin'] },
  { label: 'Pagos',          path: '/admin/payments',  icon: <ReceiptLongIcon />, roles: ['TenantAdmin'] },
  { label: 'Usuarios',       path: '/admin/users',     icon: <GroupIcon />,       roles: ['TenantAdmin'] },
  { label: 'Logs',           path: '/admin/logs',      icon: <EventNoteIcon />,   roles: ['TenantAdmin'] },
];

/** Tenant admin o SuperAdmin: menú completo. Cualquier otro rol: solo ítems con `payNav`. */
export function visibleNavItems(roleName: string | null, isSuperAdmin: boolean): NavItem[] {
  const tenantAdmin = roleName === 'TenantAdmin';
  const fullAdminNav = isSuperAdmin || tenantAdmin;

  return NAV_ITEMS.filter((item) => {
    if (!fullAdminNav) return item.payNav === true;
    if (isSuperAdmin) return true;
    if (!item.roles?.length) return true;
    return !!roleName && item.roles.includes(roleName);
  });
}

/** Todos los ítems de navegación visibles (mismo orden que el cajón lateral). */
export function getAppBottomBarItems(items: NavItem[]): NavItem[] {
  return items;
}

/** Alias (compat.): mismo comportamiento que `getAppBottomBarItems`. */
export const getAppBottomBar = getAppBottomBarItems;

export function isNavPathActive(path: string, pathname: string): boolean {
  if (path === '/home') return pathname === '/home' || pathname === '/';
  return pathname === path || pathname.startsWith(`${path}/`);
}

/** Etiqueta en el cajón / barra inferior (el operador ve "Elegir y pagar" en /home). */
export function getNavItemDisplayLabel(
  item: NavItem,
  roleName: string | null,
  isSuperAdmin: boolean,
): string {
  if (item.path === '/home' && !isSuperAdmin && roleName === ROLE.OPERATOR) {
    return 'Elegir y pagar';
  }
  return item.label;
}
